import getCorePersonalStore from "../../../../../stores/core/core-personal-store";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import Et3Button from "../../../../../core/et3-button";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";

const TableChangeForKhattabat = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const shouldShow = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const userAdvancedTableShown =
    getUserAdvancedStore().userAdvancedTableToShow.get();

  return !shouldShow ? null : (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={1500}
      height={100}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{}}
      onClick={() => { }}
    >
      <Et3Button
        isEnabled={true}
        onClick={() => {
          getUserAdvancedStore().setUserAdvancedTableToShow("user_data");
        }}
        size="MEDIUM"
        text="USER_DATA"
        type={userAdvancedTableShown === "user_data" ? "GET" : ""}
      />
      <Et3Margin top={0} bottom={0} left={10} right={10} />
      <Et3Button
        isEnabled={true}
        onClick={() => {
          getUserAdvancedStore().setUserAdvancedTableToShow("user_profile");
        }}
        size="MEDIUM"
        text="USER_QUIZ"
        type={userAdvancedTableShown === "user_profile" ? "GET" : ""}
      />
    </ET3Div>
  );
});

export default TableChangeForKhattabat;
